export default {"src":"/_next/static/media/certified.5d734182.svg","height":17,"width":17};